'use client'

import SvgIcon from '@mui/material/SvgIcon'
import PropTypes from 'prop-types'

export const DeleteIcon = ({ sx }) => {
  return (
    <SvgIcon sx={sx} data-testid="DeleteIcon">
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_4233_29160)">
          <path
            d="M17.5 3.75L15.99 18.0908C15.947 18.5003 15.7539 18.8794 15.448 19.1549C15.1421 19.4305 14.7451 19.5831 14.3333 19.5833H5.66667C5.2548 19.5833 4.85753 19.4308 4.55146 19.1552C4.24539 18.8796 4.05221 18.5004 4.00917 18.0908L2.5 3.75"
            stroke="#3D517B"
            strokeOpacity="0.56"
            strokeWidth="0.833333"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M0.416748 3.75H19.5834"
            stroke="#3D517B"
            strokeOpacity="0.56"
            strokeWidth="0.833333"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M6.25 3.75033V1.25033C6.25 1.02931 6.3378 0.81735 6.49408 0.66107C6.65036 0.50479 6.86232 0.416992 7.08333 0.416992H12.9167C13.1377 0.416992 13.3496 0.50479 13.5059 0.66107C13.6622 0.81735 13.75 1.02931 13.75 1.25033V3.75033"
            stroke="#3D517B"
            strokeOpacity="0.56"
            strokeWidth="0.833333"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M10 7.5V16.25"
            stroke="#3D517B"
            strokeOpacity="0.56"
            strokeWidth="0.833333"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M13.7499 7.5L13.3333 16.25"
            stroke="#3D517B"
            strokeOpacity="0.56"
            strokeWidth="0.833333"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M6.25 7.5L6.66667 16.25"
            stroke="#3D517B"
            strokeOpacity="0.56"
            strokeWidth="0.833333"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </svg>
    </SvgIcon>
  )
}

DeleteIcon.propTypes = {
  sx: PropTypes.object
}
